<template>
    <yandex-map :style="{height: mapHeight ? mapHeight + 'px' : '100%'}"
                :coords="coords"
                :zoom="10"
                :controls="['zoomControl']"
                :cluster-options="clusterOptions"
    >
        <ymap-marker v-for="(point, key) in data"
            :key="key"
            :marker-id="key"
            :coords="[point.place.lat, point.place.long]"
            :balloon="{
                body: balloonTemplate(point),
            }"
            :cluster-name="1"
        >
        </ymap-marker>
    </yandex-map>
</template>

<script>
import {yandexMap, ymapMarker} from 'vue-yandex-maps';
import useEvents from '../composables/events';
import {onMounted} from 'vue';

export default {
    data: () => ({
        clusterOptions: {
            1: {
                clusterDisableClickZoom: true,
                clusterOpenBalloonOnClick: true,
                clusterBalloonLayout: [
                    '<ul class=ymaps-cluster-point-list>',
                        '{% for item in properties.geoObjects %}',
                            '<li class=ymaps-cluster-point-list-item>{{ item.properties.balloonContentBody|raw }}</li>',
                        '{% endfor %}',
                    '</ul>',
                ].join(''),
            },
        },
    }),
    props: {
        coords: {
            required: true,
            type: Array
        },
        points: {
            required: false,
            type: Array
        },
        mapHeight: {
            required: false,
            type: Number
        },
        contacts: {
            required: true,
            type: Boolean
        },
        merchants: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    components: {
        yandexMap,
        ymapMarker,
    },
    setup(props) {
        const { events, getEvents } = useEvents()

        if(props.contacts === false && props.merchants === false) {
            onMounted(getEvents);
        }

        const data = props.contacts || props.merchants ? props.points : events;

        const balloonTemplate = (point) => {
            if(props.merchants) {
                return `
                    <div class="ymaps-balloon">
                        <div class="ymaps-balloon__data">
                            <img class="img-fluid" src="${point.merchant.image_urls.main}">
                        </div>

                        <div class="ymaps-balloon__title">
                            <a href="/merchants/${point.merchant.slug}">
                                ${point.merchant.name}
                            </a>
                        </div>
                    </div>
                `;
            }

            if(props.contacts) {
                const phones = point.place.phones.map((elem) => elem.phone).join(",");
                let subways = '';

                point.place.subways.forEach((subway) => {
                    subways += `
                        <span class="b-event__contacts-subway">
                            <span class="w-subwayPointer" style="background: ${subway.color};">М</span>
                            <span class="b-event__contacts-subway-name">${subway.name}</span>
                        </span>
                    `;
                });

                return `
                    <div class="ymaps-contacts">
                        <div class="ymaps-contacts__row">
                            ${point.place.name},
                            ${subways}
                        </div>
                        <div class="ymaps-contacts__row">${phones}</div>
                        <div class="ymaps-contacts__row">
                            ${point.place.work_time}
                        </div>
                    </div>
                `;
            }

            return `
                <div class="ymaps-balloon">
                    <div class="ymaps-balloon__data">
                        <img class="img-fluid" src="${point.event.image_urls.main}">
                        <span class="ymaps-balloon__discount">-${point.event.discount}%</span>
                        <div class="ymaps-balloon__views"><span>${point.event.views_count}</span></div>
                        <div class="ymaps-balloon__value">
                            <div class="ymaps-balloon__time">${point.event.duration}</div>
                            <div class="ymaps-balloon__price">от ${point.event.price}<span class="rouble">i</span></div>
                        </div>
                    </div>
                    <div class="ymaps-balloon__brand">${point.event.merchant.name}</div>
                    <div class="ymaps-balloon__title">
                        <a href="/events/${point.event.slug}">
                            ${point.event.list_title}
                        </a>
                    </div>
                    <div class="ymaps-balloon__bottom">
                        <div class="ymaps-balloon__age">${point.event.age_limit}+</div>
                    </div>
                </div>
            `
        }

        return {
            data,
            balloonTemplate
        }
    },
}
</script>

<style>
.ymaps-balloon {
    max-width: 228px;
}

.ymaps-balloon__data {
    border-radius: 10px;
    margin-bottom: 9px;
    overflow: hidden;
    position: relative;
}

.ymaps-balloon__data::before {
    content: "";
    background: -webkit-gradient(linear, left top, left bottom, color-stop(51.04%, rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.4)));
    background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 51.04%, rgba(0, 0, 0, 0.4) 100%);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 51.04%, rgba(0, 0, 0, 0.4) 100%);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    border-radius: 10px;
}

.ymaps-balloon__data img {
    -webkit-transition: all .5s ease-in-out 0s;
    -o-transition: all .5s ease-in-out 0s;
    transition: all .5s ease-in-out 0s;
}

.ymaps-balloon__discount {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    background: #fe5a00;
    color: #fff;
    border-radius: 10px;
    position: absolute;
    z-index: 5;
    top: 10px;
    left: 10px;
    height: 20px;
    width: 64px;
}

.ymaps-balloon__views {
    font-size: 10px;
    line-height: 1;
    color: #fff;
    position: absolute;
    z-index: 5;
    top: 19px;
    right: 13px;
}

.ymaps-balloon__views span {
    display: inline-block;
    background: url("../../images/event/icon-views.svg") no-repeat top left;
    background-size: 12px 9px;
    padding-left: 13px;
}

.ymaps-balloon__value {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    color: #fff;
    position: absolute;
    z-index: 5;
    bottom: 10px;
    left: 14px;
    width: calc(100% - 24px);
    -webkit-transition: all .3s ease-in-out 0s;
    -o-transition: all .3s ease-in-out 0s;
    transition: all .3s ease-in-out 0s;
}

.ymaps-balloon__time {
    font-size: 10px;
    line-height: 12px;
    color: #fff;
    background: url("../../images/event/icon-time-small.svg") no-repeat center left;
    padding-left: 13px;
}

.ymaps-balloon__price {
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
}

.ymaps-balloon__brand {
    color: #8E8989;
    font-size: 10px;
    line-height: 18px;
    margin-bottom: 4px;
}

.ymaps-balloon__title {
    color: #333;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    margin-bottom: 14px;
}

.ymaps-balloon__bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.ymaps-balloon__button {
    font-size: 12px;
    padding: 4px 15px;
}

.ymaps-balloon__age {
    color: #8E8989;
    font-size: 10px;
}

.ymaps-contacts {
    color: #333;
    font-size: 12px;
    line-height: 14px;
    max-width: 214px;
}

.ymaps-contacts__row {
    margin-bottom: 14px;
}

.ymaps-contacts__row:last-child {
    margin-bottom: 0;
}

.ymaps-contacts .b-event__contacts-subway {
    display: block;
}
</style>
